import { createContext } from "react";

import type { OpenSearchProductsContextValue } from "../types/products";

const OpenSearchProductsContext =
    createContext<OpenSearchProductsContextValue | null>(null);
OpenSearchProductsContext.displayName = "OpenSearchProductsContext";

export { OpenSearchProductsContext };
export type { OpenSearchProductsContextValue };
